import { Button, Card, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';

export default function EnterprisesFilterPanel({ onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Card
            size="small"
            className="eha-enterprises-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="企业用户昵称" name="nickName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="企业用户昵称" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="企业用户手机" name="memMobile" style={filterFormItemStyle}>
                            <Input allowClear placeholder="企业用户手机" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="医企+会员" name="vip" style={filterFormItemStyle}>
                            <Select
                                placeholder="请选择医企+会员"
                                options={[
                                    { value: -1, label: '全部' },
                                    { value: 0, label: '无等级' },
                                    { value: 1, label: '黄金会员' },
                                    { value: 2, label: '钻石会员' },
                                    { value: 3, label: '超级会员' },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
